import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { Details } from './Details';
import { StyledTableHeaderCell } from 'views/TirePressure/Components/NotificationTable.styles';
import type { SquaresAlert, AlertData } from 'types/squares.type';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const TableView = ({
  enableDarkTheme,
  notification,
}: {
  enableDarkTheme: boolean;
  notification: SquaresAlert;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const fontColor = palette.textPrimary;

  return (
    <Box>
      <Details enableDarkTheme={enableDarkTheme} notification={notification} />
      <Typography
        sx={{
          fontSize: '12px',
          color: ThemePalette.typography.grey,
          fontWeight: '600',
        }}
      >
        {t('description')}
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          color: fontColor,
          marginTop: '10px',
        }}
        dangerouslySetInnerHTML={{ __html: notification.message }}
      />

      <Typography
        sx={{
          fontSize: '12px',
          color: ThemePalette.typography.grey,
          marginTop: '40px',
          fontWeight: '600',
        }}
      >
        {t('repeated_work_orders')}
      </Typography>
      <Box
        sx={{
          marginTop: '20px',
        }}
      >
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('work_order_no')}
                </StyledTableHeaderCell>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('date')}
                </StyledTableHeaderCell>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('component')}
                </StyledTableHeaderCell>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('sub_component_2')}
                </StyledTableHeaderCell>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('description')}
                </StyledTableHeaderCell>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('status')}
                </StyledTableHeaderCell>
                <StyledTableHeaderCell enabledarktheme={enableDarkTheme}>
                  {t('action_performed')}
                </StyledTableHeaderCell>
                {/* <StyledTableHeaderCell enabledarktheme={enableDarkTheme} /> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {notification.data.map((row: AlertData, index: number) => {
                return (
                  <TableRow
                    key={index}
                    sx={{
                      '& td': {
                        border: 'none',
                        borderBottom: '1px solid #2F445E',
                      },
                    }}
                  >
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        {row.work_order_number}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        {row.date_of_orders}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        {row.components_category}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        {row.sub_component_categories?.replace(/\[|\]/g, '')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        {row.description}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'inline-block',
                            backgroundColor:
                              row.work_order_status === 'Open'
                                ? '#327FF1'
                                : '#039161',
                            color: fontColor,
                            padding: '6px 16px',
                            borderRadius: '999px',
                            minWidth: '70px',
                            fontSize: '12px',
                            fontWeight: 600,
                            backdropFilter: 'blur(1px)',
                            textAlign: 'center',
                          }}
                        >
                          {row.work_order_status}
                        </Box>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'inline-block',
                            backgroundColor:
                              row.actions_performed === 'REPLACE'
                                ? 'rgba(244, 67, 54, 0.25)'
                                : 'rgba(242, 181, 68, 0.25)',
                            color:
                              row.actions_performed === 'REPLACE'
                                ? '#F44336'
                                : '#F5B544',
                            padding: '6px 16px',
                            borderRadius: '999px',
                            fontSize: '12px',
                            fontWeight: 600,
                            backdropFilter: 'blur(1px)',
                            minWidth: '50px',
                            textAlign: 'center',
                          }}
                        >
                          {row.actions_performed}
                        </Box>
                      </Typography>
                    </TableCell>
                    {/* <TableCell>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: fontColor,
                        }}
                      >
                        <IconButton
                          sx={{
                            color: fontColor,
                          }}
                        >
                          <ArrowForwardIosIcon
                            sx={{
                              fontSize: '12px',
                            }}
                          />
                        </IconButton>
                      </Typography>
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};
